module.exports = __webpack_public_path__ + "static/media/6.Pressure Booster Pump.ff7d0eae.jpg";